/**
 * Roosterkleuren. Avond = start 18:00 of later, past bij preset
 * 'Wass. avond' (18:00-21:30). Alleen wasserij: routes starten 's ochtends.
 */

export const AVOND_SHIFT_CHIP = 'bg-orange-100 text-orange-800 border-orange-200';

export function isAvondShift(timeFrom: string | null | undefined): boolean {
  const hhmm = timeFrom?.slice(0, 5);
  return !!hhmm && hhmm >= '18:00';
}

/** Hele dag alleen avond: planner moet dat zien i.p.v. een volle 'ingepland'. */
export function isAvondOnlyDay(
  shifts: Array<{ shift_type: string | null; time_from: string | null }>,
): boolean {
  return shifts.length > 0 && shifts.every(
    (s) => s.shift_type === 'wasserij' && isAvondShift(s.time_from),
  );
}

export function shiftChipClass(
  shiftType: string | null | undefined,
  timeFrom: string | null | undefined,
): string {
  if (shiftType === 'wasserij' && isAvondShift(timeFrom)) {
    return AVOND_SHIFT_CHIP;
  }
  if (shiftType === 'wasserij') return 'bg-blue-100 text-blue-800 border-blue-200';
  if (shiftType === 'route') return 'bg-emerald-100 text-emerald-800 border-emerald-200';
  if (shiftType === 'kantoor') return 'bg-purple-100 text-purple-800 border-purple-200';
  return 'bg-slate-100 text-slate-700 border-slate-200';
}
